module.exports = __webpack_public_path__ + "static/media/CARD_PLATINUM@3x.d499b1ce.png";